export default "__VITE_ASSET__Dc3q54m8__"